import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Footer } from '../components/Footer';
export function Datenschutz() {
  return <HelmetProvider data-id="element-110">
      <div className="min-h-screen bg-background text-text-primary font-sans flex flex-col" data-id="element-111">
        <Helmet data-id="element-112">
          <title data-id="element-113">Datenschutzerklärung | Caro Loesel</title>
          <meta name="robots" content="noindex, nofollow" data-id="element-114" />
        </Helmet>

        <main className="flex-grow container mx-auto px-4 py-12 md:py-20 max-w-3xl" data-id="element-115">
          <Link to="/" className="inline-flex items-center text-hotpink hover:text-hotpink/80 transition-colors mb-8 font-medium" data-id="element-116">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-117" />
            Zurück zur Startseite
          </Link>

          <h1 className="text-3xl md:text-4xl font-heading font-bold text-text-primary mb-8" data-id="element-118">
            Datenschutzerklärung
          </h1>

          <div className="space-y-8 text-text-secondary leading-relaxed" data-id="element-119">
            <section data-id="element-120">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-121">
                1. Datenschutz auf einen Blick
              </h2>
              <h3 className="font-semibold text-text-primary mb-2" data-id="element-122">
                Allgemeine Hinweise
              </h3>
              <p className="mb-4" data-id="element-123">
                Die folgenden Hinweise geben einen einfachen Überblick darüber,
                was mit Ihren personenbezogenen Daten passiert, wenn Sie diese
                Website besuchen. Personenbezogene Daten sind alle Daten, mit
                denen Sie persönlich identifiziert werden können. Ausführliche
                Informationen zum Thema Datenschutz entnehmen Sie unserer unter
                diesem Text aufgeführten Datenschutzerklärung.
              </p>
              <h3 className="font-semibold text-text-primary mb-2" data-id="element-124">
                Datenerfassung auf dieser Website
              </h3>
              <p data-id="element-125">
                <strong data-id="element-126">
                  Wer ist verantwortlich für die Datenerfassung auf dieser
                  Website?
                </strong>
                <br data-id="element-127" />
                Die Datenverarbeitung auf dieser Website erfolgt durch den
                Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum
                dieser Website entnehmen.
              </p>
            </section>

            <section data-id="element-128">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-129">
                2. Hosting und Content Delivery Networks (CDN)
              </h2>
              <p data-id="element-130">
                Wir hosten die Inhalte unserer Website bei einem externen
                Anbieter. Die personenbezogenen Daten, die auf dieser Website
                erfasst werden, werden auf den Servern des Hosters gespeichert.
                Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen,
                Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten,
                Namen, Webseitenzugriffe und sonstige Daten, die über eine
                Website generiert werden, handeln.
              </p>
            </section>

            <section data-id="element-131">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-132">
                3. Allgemeine Hinweise und Pflichtinformationen
              </h2>
              <h3 className="font-semibold text-text-primary mb-2" data-id="element-133">
                Datenschutz
              </h3>
              <p className="mb-4" data-id="element-134">
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen
                Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten
                vertraulich und entsprechend der gesetzlichen
                Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>
              <h3 className="font-semibold text-text-primary mb-2" data-id="element-135">
                Hinweis zur verantwortlichen Stelle
              </h3>
              <p className="mb-4" data-id="element-136">
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser
                Website ist:
                <br data-id="element-137" />
                <br data-id="element-138" />
                EXXOTIC Management UG
                <br data-id="element-139" />
                Äußere Bayreuther Str. 59
                <br data-id="element-140" />
                90409 Nürnberg
                <br data-id="element-141" />
                Deutschland
                <br data-id="element-142" />
                <br data-id="element-143" />
                E-Mail: info@exxotic-management.com
              </p>
            </section>

            <section data-id="element-144">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-145">
                4. Datenerfassung auf dieser Website
              </h2>
              <h3 className="font-semibold text-text-primary mb-2" data-id="element-146">Cookies</h3>
              <p className="mb-4" data-id="element-147">
                Unsere Internetseiten verwenden so genannte „Cookies“. Cookies
                sind kleine Textdateien und richten auf Ihrem Endgerät keinen
                Schaden an. Sie werden entweder vorübergehend für die Dauer
                einer Sitzung (Session-Cookies) oder dauerhaft (permanente
                Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies werden
                nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies
                bleiben auf Ihrem Endgerät gespeichert, bis Sie diese selbst
                löschen oder eine automatische Löschung durch Ihren Webbrowser
                erfolgt.
              </p>
              <h3 className="font-semibold text-text-primary mb-2" data-id="element-148">
                Server-Log-Dateien
              </h3>
              <p data-id="element-149">
                Der Provider der Seiten erhebt und speichert automatisch
                Informationen in so genannten Server-Log-Dateien, die Ihr
                Browser automatisch an uns übermittelt. Dies sind:
              </p>
              <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-150">
                <li data-id="element-151">Browsertyp und Browserversion</li>
                <li data-id="element-152">Verwendetes Betriebssystem</li>
                <li data-id="element-153">Referrer URL</li>
                <li data-id="element-154">Hostname des zugreifenden Rechners</li>
                <li data-id="element-155">Uhrzeit der Serveranfrage</li>
                <li data-id="element-156">IP-Adresse</li>
              </ul>
            </section>

            <section data-id="element-157">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-158">
                5. Analyse-Tools und Werbung
              </h2>
              <p data-id="element-159">
                Soweit Sie Ihre Einwilligung erklärt haben, wird auf dieser
                Website Google Analytics eingesetzt, ein Webanalysedienst der
                Google LLC. Zuständiger Dienstanbieter in der EU ist die Google
                Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland
                („Google“).
              </p>
            </section>

            <section data-id="element-160">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-161">
                6. Plugins und Tools
              </h2>
              <h3 className="font-semibold text-text-primary mb-2" data-id="element-162">
                Google Web Fonts
              </h3>
              <p data-id="element-163">
                Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten
                so genannte Web Fonts, die von Google bereitgestellt werden.
                Beim Aufruf einer Seite lädt Ihr Browser die benötigten Web
                Fonts in ihren Browsercache, um Texte und Schriftarten korrekt
                anzuzeigen.
              </p>
            </section>
          </div>
        </main>

        <Footer data-id="element-164" />
      </div>
    </HelmetProvider>;
}